import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as Sentry from "@sentry/react";

if (process.env.REACT_APP_ENV !== 'development') {

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN_KEY,
    tracesSampleRate: 1.0,
    environment: process.env.REACT_APP_ENV,
    integrations: function(integrations) {
      // integrations will be all default integrations
      return integrations.filter(function(integration) {
        return integration.name !== "Dedupe";
      });
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"), {
  ...(process.env.REACT_APP_ENV !== 'development' && {
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn('Uncaught error', error, errorInfo.componentStack);
    }),
    onCaughtError: Sentry.reactErrorHandler(),
    onRecoverableError: Sentry.reactErrorHandler(),
  })
});

root.render(
      <React.StrictMode>
          <App />
      </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
